module.exports = __webpack_public_path__ + "static/media/13_sognolucido.fc6b18bd.jpg";